import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect, useMemo } from 'react';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.idEscola;
export default function Instituicao() {
  const { state, dispatch, validator, loadInstituicoes } =
    useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'idEscola',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  useEffect(() => {
    loadInstituicoes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = useMemo(() => {
    return state.options.instituicao.options
      ? getOptionsFromParams(state.options.instituicao.options, 'id', (i) =>
          i.nome.toUpperCase()
        )
      : [];
  }, [state.options.instituicao.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          label={language.label}
          placeholder={language.placeholder}
          loading={state.options.instituicao.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.idEscola}
          onChange={(option: { value: number; label: string }) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                idEscola: option?.value ?? null,
                codigoCooperativa: null,
                cpfsProfessores: [],
                cpfsAssessores: [],
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
